/**
 * Empty function
 */
const noop = () => {}

module.exports = noop
